export enum Genders {
    Male = 'Male',
    Female = 'Female',
}

export const GendersMap = {
    [Genders.Male]: 'Male',
    [Genders.Female]: 'Female',
};
